import React, {useEffect, useState} from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Auth, LoadingComponent} from 'recupero-comunes'
import { Card, Container } from 'react-bootstrap'
import BuscarCasos from './buscar-casos'
import BandejaCasos from './bande-casos'
import { obtenerDatosLlaves, configuracionFormAction87, obtenerComboTipoFecha, obtenerFechas } from '../../store/actions/area-busqueda-ingreso-recuperos-cuota-action'

const AreaIngresoRecuperosCuota = () => {

    const { rutOrganizacion } = Auth.currentUser()

    const [loading, setLoading]=useState(false)
    const [myQueryState, setMyQuery]=useState(null)
    const {state}=useLocation()
    const idOrganizacionCaso = rutOrganizacion;
    
    const dispatch = useDispatch()
    
    const data_areaBuscar = useSelector((state) => state.areaBusquedaCasosIngresoRecuperoReducer)
    const {cfg_form87, llaves} = data_areaBuscar

    useEffect(()=>{    
        dispatch(obtenerDatosLlaves({idOrgCaso:idOrganizacionCaso}))
    },[dispatch])

    useEffect(() => {
        if(llaves){ 
            setLoading(true)
            let query = Buffer.from(JSON.stringify({
                rutcia: llaves && llaves['idOrgCaso'],
                idform: 87
            })).toString('base64')
            dispatch(configuracionFormAction87(query))
            .then(()=>{
                let query = Buffer.from(JSON.stringify({
                    "rutcia": idOrganizacionCaso,
                    "parametro": 1
                })).toString('base64')
                dispatch(obtenerFechas(query))
            })            
            .then(()=>{
                let query = Buffer.from(JSON.stringify({concepto: 297})).toString('base64')
                dispatch(obtenerComboTipoFecha(query))
            })
            .then(()=>setLoading(false))
        }
     }, [dispatch,llaves])
    
    return (
        <div> 
            <LoadingComponent show={loading}/>
            <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                    {(cfg_form87 && cfg_form87.cfg_form87['consultacasos-filtrobusqueda']) ? `${cfg_form87.cfg_form87['consultacasos-filtrobusqueda']}`: 'Ingreso Recupero por Cuota'}
                </Card.Header>
                <Card.Body>
                    <BuscarCasos setMyQuery={setMyQuery} />
                    <BandejaCasos myQueryState={myQueryState} />                  
             </Card.Body>
            </Card>
            </Container> 
        </div>
    )
}

export default AreaIngresoRecuperosCuota
